const AppTheme = {
    h1: {
        fontWeight: '400'
    },
    h2: {
        fontWeight: '400',
        textAlign: 'left'
    },
    h3: {
        fontWeight: '400',
        textAlign: 'left'
    },
    h4: {
        fontWeight: '400',
        textAlign: 'left'
    },
    h5: {
        fontWeight: '400',
        textAlign: 'left'
    },
    pre: {
        background: '#f8f8f8'
    },
    container: {
        textAlign: 'center'
    },
    section: {
        textAlign: 'left',
        padding: '0 1em'
    },
    lineBreak: {
        height: '0',
        borderBottom: '1px solid #ededed',
        margin: '1em 10%'
    },
    form: {
        display: 'inline-block',
        width: '320px',
        marginTop: '100px'
    },
    inputRow: {
        display: 'block',
        marginTop: '0.5em'
    },
    input: {
        width: '100%',
        fontSize: '1em',
        // padding: '0.5em',
        boxSizing: 'border-box',
        border: 'solid 1px #e0e0e0',
        padding: '10px',
        borderRadius: '10px',
        color: '#393838'
    },
    inputLabel: {
        display: 'block',
        textAlign: 'left'
    },
    actionRow: {

        marginTop: '0.5em'

    },
    actionRowSignin: {
        marginTop: '0.5em',
        textAlign: 'right'
    },
    actionRowleft: {
        marginTop: '0.5em',
        textAlign: 'left'
    },
    action: {
        // fontSize: '1em',
        border: 'solid 1px #23b8dc',
        outline: 'none',
        padding: '5px 10px',
        backgroundColor: '#fff',
        cursor: 'pointer',
        color: '#23b8dc',
        borderRadius: '25px',
        width: '155px',
        fontSize: '18px'
    },
    footer: {
        marginTop: '1em'
    },
    footerLeft: {
        minWidth: '100px',
        maxWidth: '155px',
        float: 'left',
        width: '155px'
    },
    footerRight: {
        float: 'right',
        minWidth: '100px',
        maxWidth: '155px',
        width: '155px'
    },
    link: {
        textDecoration: 'none',
        cursor: 'pointer',
        fontSize: '16px',
        color: '#23b8dc'
    },
    error: {
        background: 'orange',
        padding: '0.5em',
        marginTop: '2em',
        color: 'white'
    },
    success: {
        background: '#23b8dc',
        padding: '0.5em',
        marginTop: '2em',
        color: 'white'
    },

    nav: {
        marginBottom: '1em',
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: 'grey',
        color: '#fff',
        padding: '1em',
        item: {
            fontWeight: '500',
            padding: '0 0.5em',
            cursor: 'pointer'
        },
        greeting: {
            fontWeight: '500',
            color: '#000',
            padding: '0 0.5em'
        },

        main: {
            flexGrow: '1',
            textAlign: 'left'
        },
        right: {
            fontSize: '0.8em'
        }
    }
}

export default AppTheme
